<template>
  <div class="section section--alt-background section--half-y-padding">
    <p>
      {{ menuListFilterContent }}

      <button
        type="button"
        class="link primary"
        @click="handleClearFiltersClick"
      >
        Clear Filters
      </button>
    </p>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'MenuListFilterBanner',

    computed: {
      ...mapGetters('menu', ['menu']),

      menuListFilterContent() {
        return this.menu.filteredCategories.length > 0
          ? 'Menu is currently being filtered.'
          : 'There are no results that match your filters.';
      }
    },

    methods: {
      handleClearFiltersClick() {
        this.$store.dispatch('menu/updateSelectedFilters', []);
      }
    }
  };
</script>
